<script>
import UserService from "@/helpers/APIService/user.service";
import { authComputed } from "@/state/helpers";
import {
  required,
  decimal,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
import errorHandler from "../../helpers/errorHandler";

export default {
  data() {
    return {
      roomType: {
        name: "",
        short_name: "",
        bad_type: null,
        room_size: 0,
        std_rate: "10.00",
        kiosk_rate: "10.00",
        max_adult: 2,
        max_children: 1,
        hk_stay_over_duration: "00:15:00",
        hk_check_out_duration: "00:15:00",
        hk_stay_over_credit: 10,
        hk_check_out_credit: 5,
        features: {
          Hour24Security: false,
          BBQFacilities: false,
          Babysitting: false,
          BarLoungeBeach: false,
          BusinessCentre: false,
          CarRentalDesk: false,
          ChildrenActivities: false,
          ConferenceFacilities: false,
          CurrencyExchangeServices: false,
          DryCleaning: false,
          ElderAccess: false,
          Elevator: false,
          FamilyRooms: false,
          FarmRanch: false,
          FirstAidKit: false,
          FreeInternet: false,
          FreeParking: false,
          FreeTransfer: false,
          FreeWiFi: false,
          GameRoom: false,
          Golf: false,
          GuestLaundry: false,
          GymFitnessCenter: false,
          HairSalon: false,
          HotTub: false,
          Kitchen: false,
          Kitchenette: false,
          LimitedParking: false,
          LockersStorage: false,
          LoyaltyProgram: false,
          MeetingRoom: false,
          NonSmokingRoomsFloors: false,
          PaidInternet: false,
          PaidParking: false,
          PaidWiFi: false,
          PetFriendly: false,
          PhotocopyServices: false,
          Pool: false,
          Porterage: false,
          Restaurant: false,
          RoomService: false,
          Sauna: false,
          Shuttle: false,
          Spa: false,
          SwimmingPool: false,
          TennisCourt: false,
          TourDesk: false,
          ValetParking: false,
          WheelchairAccess: false,
        },
        is_enable_ota: false,
        is_enable_web: false,
        is_enable_kiosk: false,
        is_common_type: false,
        is_active: true,
        edit: false,
        id: null,
      },
      room_bad_type: [],
      submitted: false,
      is_btn_loading: false,
      isSaveAndAddNew: false,
    };
  },
  components: {},
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "cancelSubmit"],
  computed: {
    ...authComputed,
  },
  validations: {
    roomType: {
      name: {
        required,
      },
      short_name: {
        required,
      },
      bad_type: {
        required,
      },
      std_rate: {
        decimal,
      },
      kiosk_rate: {
        decimal,
      },
      hk_stay_over_credit: {
        required,
        minValueValue: minValue(1),
        maxValueValue: maxValue(99),
      },
      hk_check_out_credit: {
        required,
        minValueValue: minValue(1),
        maxValueValue: maxValue(99),
      },
    },
  },
  mounted() {
    this.setIfEdit();
    this.getBadTypeList();
  },
  methods: {
    setIfEdit() {
      if (this.currentProps.isEdit) {
        this.roomType.name = this.currentProps.selectedRoomType.name;
        this.roomType.short_name =
          this.currentProps.selectedRoomType.short_name;
        this.roomType.bad_type = this.currentProps.selectedRoomType.bad_type.id;
        this.roomType.room_size = this.currentProps.selectedRoomType.room_size;
        this.roomType.hk_stay_over_credit =
          this.currentProps.selectedRoomType.hk_stay_over_credit;
        this.roomType.hk_check_out_credit =
          this.currentProps.selectedRoomType.hk_check_out_credit;
        this.roomType.std_rate = this.currentProps.selectedRoomType.std_rate;
        this.roomType.kiosk_rate =
          this.currentProps.selectedRoomType.kiosk_rate;
        this.roomType.max_adult = this.currentProps.selectedRoomType.max_adult;
        this.roomType.max_children =
          this.currentProps.selectedRoomType.max_children;
        this.roomType.features = this.currentProps.selectedRoomType.features;
        this.roomType.features = this.roomType.features.reduce(
          (a, v) => ({ ...a, [v]: v }),
          {}
        );
        this.roomType.is_common_type =
          this.currentProps.selectedRoomType.is_common_type;
        this.roomType.is_enable_ota =
          this.currentProps.selectedRoomType.is_enable_ota;
        this.roomType.is_enable_web =
          this.currentProps.selectedRoomType.is_enable_web;
        this.roomType.is_enable_kiosk =
          this.currentProps.selectedRoomType.is_enable_kiosk;
        this.roomType.is_active = this.currentProps.selectedRoomType.is_active;
      }
    },
    // Method is use for get bad type list
    async getBadTypeList() {
      try {
        const response = await UserService.getBadList();
        response.map((item) => {
          this.room_bad_type.push({
            value: item.id,
            text: item.short_name + " - " + item.name,
          });
        });
      } catch (error) {
        errorHandler(error);
      }
    },
    onSubmit() {
      this.submitted = true;
      this.is_btn_loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.is_btn_loading = false;
        return;
      } else {
        let features = [];
        Object.keys(this.roomType.features).map((feature) => {
          if (this.roomType.features[feature] !== false) {
            features.push(feature);
          }
        });
        let roomTypeData = new FormData();
        roomTypeData.append("name", this.roomType.name);
        roomTypeData.append("short_name", this.roomType.short_name);
        roomTypeData.append("bad_type", this.roomType.bad_type);
        roomTypeData.append("room_size", this.roomType.room_size);
        roomTypeData.append("std_rate", this.roomType.std_rate);
        roomTypeData.append("kiosk_rate", this.roomType.kiosk_rate);
        roomTypeData.append("max_adult", this.roomType.max_adult);
        roomTypeData.append("max_children", this.roomType.max_children);
        roomTypeData.append(
          "hk_stay_over_duration",
          this.roomType.hk_stay_over_duration
        );
        roomTypeData.append(
          "hk_check_out_duration",
          this.roomType.hk_check_out_duration
        );
        roomTypeData.append(
          "hk_stay_over_credit",
          this.roomType.hk_stay_over_credit
        );
        roomTypeData.append(
          "hk_check_out_credit",
          this.roomType.hk_check_out_credit
        );
        roomTypeData.append("features", JSON.stringify(features));
        roomTypeData.append("is_enable_ota", this.roomType.is_enable_ota);
        roomTypeData.append("is_enable_web", this.roomType.is_enable_web);
        roomTypeData.append("is_enable_kiosk", this.roomType.is_enable_kiosk);
        roomTypeData.append("is_common_type", this.roomType.is_common_type);

        roomTypeData.append("is_active", this.roomType.is_active);

        if (this.currentProps.isEdit == false) {
          roomTypeData.append("hotel", this.hotel.id);
          UserService.createRoomType(roomTypeData)
            .then(
              (roomType) => {
                if (this.isSaveAndAddNew) {
                  this.$emit("SaveAndAddNew", roomType);
                } else {
                  this.$emit("submitted", roomType);
                }
                this.is_btn_loading = false;
                this.submitted = false;
              },
              (error) => {
                this.is_btn_loading = false;
                errorHandler(error);
              }
            )
            .catch((error) => {
              errorHandler(error);
            });
        } else {
          UserService.editRoomType(
            roomTypeData,
            this.currentProps.selectedRoomType.id
          )
            .then(
              (roomType) => {
                this.$emit("submitted", roomType);
                this.is_btn_loading = false;
                this.submitted = false;
              },
              (error) => {
                this.is_btn_loading = false;
                errorHandler(error);
              }
            )
            .catch((error) => {
              errorHandler(error);
            });
        }
      }
    },
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
    SaveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.onSubmit();
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <h4>{{ this.currentProps.isEdit ? "Update" : "Add New" }} Room Type</h4>
    <hr />

    <div class="row">
      <div class="col-md-6">
        <b-form-group class="mb-3" label="Name" label-for="room_type">
          <template slot="label">
            Room Name <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="room_type"
            type="text"
            placeholder="Ex : Super Deluxe"
            autocomplete="off"
            v-model="roomType.name"
            :class="{
              'is-invalid': submitted && $v.roomType.name.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.roomType.name.required"
              >room type name is required.</span
            >
          </div>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group class="mb-3" label="Short Code" label-for="short_code">
          <template slot="label">
            Short Code <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="short_code"
            type="text"
            placeholder="Ex : SD"
            autocomplete="off"
            v-model="roomType.short_name"
            :class="{
              'is-invalid': submitted && $v.roomType.short_name.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.roomType.short_name.required"
              >room type short code name is required.</span
            >
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group
          class="mb-3 form-label"
          label="bad_type"
          label-for="room_bad_type"
        >
          <template slot="label">
            Bed Type <span class="text-danger">*</span>
          </template>
          <b-form-select
            class="form-select"
            id="bad_type"
            type="text"
            autocomplete="off"
            placeholder="select bad type"
            v-model="roomType.bad_type"
            :options="room_bad_type"
            :class="{
              'is-invalid': submitted && $v.roomType.bad_type.$error,
            }"
          >
          </b-form-select>
          <div
            v-if="submitted && $v.roomType.bad_type.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.roomType.bad_type.required">Bed is required.</span>
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group
          class="mb-3"
          label="Room Size(SQ FT.)"
          label-for="room_size"
        >
          <b-form-input
            id="room_size"
            type="number"
            autocomplete="off"
            min="1"
            v-model="roomType.room_size"
          >
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group class="mb-3" label="Standard Rate" label-for="std_rate">
          <b-form-input
            id="std_rate"
            type="number"
            autocomplete="off"
            step="0.01"
            v-model="roomType.std_rate"
            :class="{
              'is-invalid': submitted && $v.roomType.std_rate.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.roomType.std_rate.decimal"
              >Standard Rate must be in decimal.</span
            >
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group class="mb-3" label="Kiosk Rate" label-for="kiosk_rate">
          <b-form-input
            id="kiosk_rate"
            type="number"
            autocomplete="off"
            step="0.01"
            v-model="roomType.kiosk_rate"
            :class="{
              'is-invalid': submitted && $v.roomType.kiosk_rate.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.roomType.kiosk_rate.decimal"
              >Kiosk Rate must be in decimal.</span
            >
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group class="mb-3" label="Max Adult" label-for="max_adult">
          <b-form-input
            id="max_adult"
            type="number"
            autocomplete="off"
            min="1"
            v-model="roomType.max_adult"
          >
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group
          class="mb-3"
          label="Max Children"
          label-for="max_children"
        >
          <b-form-input
            id="max_children"
            type="number"
            autocomplete="off"
            min="1"
            v-model="roomType.max_children"
          >
          </b-form-input>
        </b-form-group>
      </div>

      <!-- House Keeping -->
      <div class="col-md-12">
        <h5>House Keeping</h5>
        <hr />
      </div>
      <div class="col-md-4">
        <b-form-group
          class="mb-3"
          label="house keeping duration"
          label-for="hk_stay_over_duration"
        >
          <b-form-input
            id="hk_stay_over_duration"
            type="time"
            step="1"
            v-model="roomType.hk_stay_over_duration"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group
          class="mb-3"
          label="house keeping duration"
          label-for="hk_check_out_duration"
        >
          <b-form-input
            id="hk_check_out_duration"
            type="time"
            step="1"
            v-model="roomType.hk_check_out_duration"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-4"></div>
      <div class="col-md-4">
        <b-form-group
          class="mb-3"
          label="house keeping Stay Over Credit"
          label-for="hk_stay_over_credit"
        >
          <b-form-input
            id="hk_stay_over_credit"
            type="number"
            max="99"
            min="1"
            required
            autocomplete="off"
            v-model="roomType.hk_stay_over_credit"
            :class="{
              'is-invalid': submitted && $v.roomType.hk_stay_over_credit.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.roomType.hk_stay_over_credit.required"
              >Credit is required.</span
            >
            <span v-if="!$v.roomType.hk_stay_over_credit.maxValueValue"
              >Enter Value between 1 to 99.</span
            >
            <span v-if="!$v.roomType.hk_stay_over_credit.minValueValue"
              >Enter Value between 1 to 99</span
            >
          </div>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group
          class="mb-3"
          label="house keeping Checkout Out Credit"
          label-for="hk_check_out_credit"
        >
          <b-form-input
            id="hk_check_out_credit"
            type="number"
            autocomplete="off"
            max="99"
            min="1"
            required
            v-model="roomType.hk_check_out_credit"
            :class="{
              'is-invalid': submitted && $v.roomType.hk_check_out_credit.$error,
            }"
          ></b-form-input>
          <div v-if="submitted" class="invalid-feedback">
            <span v-if="!$v.roomType.hk_check_out_credit.required"
              >Credit is required.</span
            >
            <span v-if="!$v.roomType.hk_check_out_credit.maxValueValue"
              >Enter Value between 1 to 99.</span
            >
            <span v-if="!$v.roomType.hk_check_out_credit.minValueValue"
              >Enter Value between 1 to 99</span
            >
          </div>
        </b-form-group>
      </div>
      <!-- Room Should Be Available On -->
      <div class="col-md-12">
        <h5>Room Should Be Available On</h5>
        <hr />
      </div>
      <div class="col-md-3">
        <div class="form-check form-switch form-switch-md mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="is_enable_ota"
            v-model="roomType.is_enable_ota"
          />
          <label class="form-check-label" for="is_enable_ota">OTA</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check form-switch form-switch-md mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="is_enable_web"
            v-model="roomType.is_enable_web"
          />
          <label class="form-check-label" for="is_enable_web">Web</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check form-switch form-switch-md mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="is_enable_kiosk"
            v-model="roomType.is_enable_kiosk"
          />
          <label class="form-check-label" for="is_enable_kiosk">Kiosk</label>
        </div>
      </div>

      <!-- Room Type Available -->
      <div class="col-md-12">
        <h5 class="mt-2">Room Type Available</h5>
        <hr />
      </div>
      <div class="col-md-3">
        <div class="form-check form-switch form-switch-md mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="is_active"
            name="status"
            checked
            v-model="roomType.is_active"
          />
          <label class="form-check-label" for="is_active">Active</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check form-switch form-switch-md mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="is_common_type"
            checked
            v-model="roomType.is_common_type"
          />
          <label class="form-check-label" for="is_common_type"
            >Common Type</label
          >
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <h5 class="mt-2">Features</h5>
      <hr />
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Airconditioning"
            v-model="roomType.features.Airconditioning"
          />
          <label class="form-check-label" for="Airconditioning"
            >Air conditioning</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Microwave"
            v-model="roomType.features.Microwave"
          />
          <label class="form-check-label" for="Microwave">Microwave</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Dataport"
            v-model="roomType.features.Dataport"
          />
          <label class="form-check-label" for="Dataport">Data port </label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Desk"
            v-model="roomType.features.Desk"
          />
          <label class="form-check-label" for="Desk">Desk</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Electrickettle"
            v-model="roomType.features.Electrickettle"
          />
          <label class="form-check-label" for="Electrickettle"
            >Electric kettle
          </label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Espressomachine"
            v-model="roomType.features.Espressomachine"
          />
          <label class="form-check-label" for="Espressomachine"
            >Espresso machine</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="FlatscreenTV"
            v-model="roomType.features.FlatscreenTV"
          />
          <label class="form-check-label" for="FlatscreenTV"
            >Flat-screen TV</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="smartTV"
            v-model="roomType.features.smartTV"
          />
          <label class="form-check-label" for="smartTV">smartTV</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Freetoiletries"
            v-model="roomType.features.Freetoiletries"
          />
          <label class="form-check-label" for="Freetoiletries"
            >Free toiletries</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Hairdryer"
            v-model="roomType.features.Hairdryer"
          />
          <label class="form-check-label" for="Hairdryer">Hairdryer</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Heating"
            v-model="roomType.features.Heating"
          />
          <label class="form-check-label" for="Heating">Heating</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Jacuzzi"
            v-model="roomType.features.Jacuzzi"
          />
          <label class="form-check-label" for="Jacuzzi"
            >Jacuzzi (in room)</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="internetaccesswifi"
            v-model="roomType.features.internetaccesswifi"
          />
          <label class="form-check-label" for="internetaccesswifi"
            >Internet access (WiFi)</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="MobileKey"
            v-model="roomType.features.MobileKey"
          />
          <label class="form-check-label" for="Mobile Key">Mobile Key</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Internetaccess"
            v-model="roomType.features.Internetaccess"
          />
          <label class="form-check-label" for="Internetaccess"
            >Internet access</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Minifridge"
            v-model="roomType.features.Minifridge"
          />
          <label class="form-check-label" for="Minifridge">Mini fridge</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Minibar"
            v-model="roomType.features.Minibar"
          />
          <label class="form-check-label" for="Minibar">Minibar</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Petsallowed"
            v-model="roomType.features.Petsallowed"
          />
          <label class="form-check-label" for="Petsallowed">Pets allowed</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Privatepool"
            v-model="roomType.features.Privatepool"
          />
          <label class="form-check-label" for="Privatepool">Private pool</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Safetydepositbox"
            v-model="roomType.features.Safetydepositbox"
          />
          <label class="form-check-label" for="Safetydepositbox"
            >Safety deposit box</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Satellitechannels"
            v-model="roomType.features.Satellitechannels"
          />
          <label class="form-check-label" for="Satellitechannels"
            >Satellite channels</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Scale"
            v-model="roomType.features.Scale"
          />
          <label class="form-check-label" for="Scale">Scale </label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Slippers"
            v-model="roomType.features.Slippers"
          />
          <label class="form-check-label" for="Slippers">Slippers</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Smokedetectors"
            v-model="roomType.features.Smokedetectors"
          />
          <label class="form-check-label" for="Smokedetectors"
            >Smoke detectors</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Soundproof"
            v-model="roomType.features.Soundproof"
          />
          <label class="form-check-label" for="Soundproof">Sound proof</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Telephonedirectdial"
            v-model="roomType.features.Telephonedirectdial"
          />
          <label class="form-check-label" for="Telephonedirectdial"
            >Telephone - direct dial</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="WardrobeorCloset"
            v-model="roomType.features.WardrobeorCloset"
          />
          <label class="form-check-label" for="WardrobeorCloset"
            >Wardrobe or Closet</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="iPoddockingstation"
            v-model="roomType.features.iPoddockingstation"
          />
          <label class="form-check-label" for="iPoddockingstation"
            >iPod docking station</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Umbrella"
            v-model="roomType.features.Umbrella"
          />
          <label class="form-check-label" for="Umbrella">Umbrella</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Sofa"
            v-model="roomType.features.Sofa"
          />
          <label class="form-check-label" for="Sofa">Sofa</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Towels"
            v-model="roomType.features.Towels"
          />
          <label class="form-check-label" for="Towels">Towels</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="ironandironingboard"
            v-model="roomType.features.ironandironingboard"
          />
          <label class="form-check-label" for="ironandironingboard"
            >Iron & ironing board (in room)</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Wakeupservice"
            v-model="roomType.features.Wakeupservice"
          />
          <label class="form-check-label" for="Wakeupservice"
            >Wake-up service/Alarm clock</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="Tableandchairs"
            v-model="roomType.features.Tableandchairs"
          />
          <label class="form-check-label" for="Tableandchairs"
            >Table and chairs (dining room style)</label
          >
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="ironandironingboardupon"
            v-model="roomType.features.ironandironingboardupon"
          />
          <label class="form-check-label" for="ironandironingboardupon"
            >Iron & ironing board (upon request)</label
          >
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <!-- save button div -->
      <div class="col-md-12">
        <b-button
          class="float-end ms-2"
          variant="outline-primary"
          type="reset"
          @click="cancelSubmit"
          >Cancel</b-button
        >
        <b-button
          v-if="this.currentProps.isEdit === false"
          class="float-end ms-2"
          variant="outline-primary"
          type="submit"
          @click="SaveAndAddNew"
          >Save & Add</b-button
        >
        <b-button
          class="float-end"
          variant="outline-primary"
          type="submit"
          @click="onSubmit"
          :class="{ disabled: is_btn_loading }"
        >
          <i
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            v-if="is_btn_loading"
          ></i>
          {{ this.currentProps.isEdit ? "Update" : "Save" }}
        </b-button>
      </div>
    </div>
  </div>
</template>
